import { IHttpService } from "../HttpService";

export interface IAuthenticationService {
  login(
    username: string,
    password: string,
    verificationCode?: string
  ): Promise<any>;
  logout(): void;
  changePassword(
    newPassword: string,
    oldPassword: string,
    username: string,
    token?: string
  ): void;
  resetPassword(username: string): Promise<string>;
}

const AuthenticationService = (httpService): IAuthenticationService => {
  const _http: IHttpService = httpService;
  const _basePath = "/login";
  const _passwordPath = "/api/password";
  const _resetPath = "/reset";

  return {
    async login(username: string, password: string, verificationCode?: string) {
      const response = await _http.post(_basePath, {
        form: true,
        params: {
          password,
          username,
          verificationCode
        }
      });
      const { languageCode, roles, twoFactorAuthRequired } = await _http.toJSON(
        response
      );
      return { languageCode, roles, twoFactorAuthRequired };
    },

    async logout() {
      let url = _http.buildPath("/logout");
      await _http.post(url);
    },

    async changePassword(
      newPassword: string,
      oldPassword: string,
      username: string,
      token?: string
    ) {
      const response = await _http.post(_passwordPath, {
        form: true,
        params: {
          newPassword,
          oldPassword,
          username,
          token
        }
      });
      return _http.toText(response);
    },

    async resetPassword(username: string) {
      const response = await _http.post(_passwordPath + _resetPath, {
        form: true,
        params: {
          username
        }
      });
      return _http.toText(response);
    }
  };
};

export default AuthenticationService;
